import { Injectable } from "@angular/core";
import { UserDataService } from "../data-service/user.data.service";
import { UserListingInterfaceData, UserProfileInterface } from "../interface/user.interface";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root',
})
export class UserService {

    user: UserListingInterfaceData;

    constructor(
        private userDataService: UserDataService,
        private router: Router) {
    }
    onInit() {
        this.updateProfile();
    }
    updateProfile() {
        this.userDataService.getProfile().subscribe({
            next: (x: any) => {
                this.user = x;
            }, error: (err) => {
                // this.router.navigate(['/login'])
            }
        });
    }
}